import clsx from 'clsx';

import type { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

import s from './ModalMain.module.css';

type ModalMainProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const ModalMain: FC<ModalMainProps> = ({ className, ...props }) => (
  <div className={clsx(s.main, className)} {...props} />
);

export { ModalMain };
